const contents = () => {
  const tableOfConents = document.querySelector('#js-table-of-contents'),
    sidebar = document.querySelector('#js-content-nav')

  if (!tableOfConents || !sidebar) return

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const id = entry.target.getAttribute('id')
      const currentElm = sidebar.querySelector(`li[data-anchor="#${id}"]`)

      if (entry.intersectionRatio > 0) {
        currentElm.classList.add('contents-visible', 'contents-active')
      } else {
        currentElm.classList.remove('contents-visible', 'contents-active')
      }
    })
  })

  tableOfConents.querySelectorAll('section[id]').forEach((section) => {
    observer.observe(section)
  })
}

export default contents
